export default __webpack_public_path__ + "static/icon-10-3-de113552cd82651ee6b9804b859f5eab.png";